import React from "react";

import PropTypes from "prop-types";
import Config from "config";

import Translate from "Components/Translate";

import "./style.scss";

const Footer = ({ links }) => {
  return (
    <div className="Footer">
      <div className="Footer__info">
        {Config.appTitle} {new Date().getFullYear()} ©
        <div className="Footer__info__address">
          Samoukale Enterprises Limited <br />
          15 Karaiskaki, 3032, Limassol, Cyprus
        </div>
      </div>
      <div className="Footer__links">
        {links.map((link) => (
          <a
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
            key={link.href}
          >
            <Translate tag={link.title} />
          </a>
        ))}
        <a href={`mailto:${Config.supportEmail}`}>{Config.supportEmail}</a>
      </div>
    </div>
  );
};

Footer.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default Footer;
